// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from 'firebase/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

// const firebaseConfig = {
//   apiKey: "AIzaSyBfEFbrWx-XMhRIJe0hHM2d2VFEI9i33sk",
//   authDomain: "botchat-a38b3.firebaseapp.com",
//   projectId: "botchat-a38b3",
//   storageBucket: "botchat-a38b3.appspot.com",
//   messagingSenderId: "78695834563",
//   appId: "1:78695834563:web:fc060e89b7ba4b93c05376",
//   measurementId: "G-Z9WKK7TVKP"
// };

const firebaseConfig = {
 
    apiKey: "AIzaSyDqS7DqPoWCs8eJhk7I9z0GxsfMyT8qWnI",
   
    authDomain: "ssoapplinks.firebaseapp.com",
   
    databaseURL: "https://ssoapplinks.firebaseio.com",
   
    projectId: "ssoapplinks",
   
    storageBucket: "ssoapplinks.firebasestorage.app",
   
    messagingSenderId: "550602191299",
   
    appId: "1:550602191299:web:1a49751a0016e16ac64d76",
   
    measurementId: "G-BR5JVM8HRT"
   
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const auth = getAuth(app);
